module.exports = __webpack_public_path__ + "static/ezs2-9e918491a34778a01e6da87c7fa593de.jpg";